const constants = {
  adminGroup: 'administrator',
  clerkGroup: 'clerk',
  supplierGroup: 'supplier'
};

export default constants;
